import {
    ASSOCIATIONS_PATCH_FAILURE,
    ASSOCIATIONS_PATCH_REQUEST,
    ASSOCIATIONS_PATCH_SUCCESS,
} from 'actions';

const initialState = {
    patching: false,
    hasErrors: false,
};

export const associationPatchReducer = (state = initialState, action) => {
    const {type, association} = action;
    switch (type) {
        case ASSOCIATIONS_PATCH_SUCCESS: {return {
            ...initialState,
            association,
        }}

        case ASSOCIATIONS_PATCH_REQUEST: {return {
            ...initialState,
            patching: true,
        }}

        case ASSOCIATIONS_PATCH_FAILURE: {return {
            ...initialState,
            hasErrors: true,
        }}

        default: { return state }
    }
};
